<div *ngIf="!isAppReady">
  <div class="login-wrapper">
    <div class="login-form">
      <div class="login-logo"></div>
      <sh-loading-indicator class="text-center d-block"></sh-loading-indicator>
    </div>
  </div>
</div>
<sh-app-shell
  *ngIf="isAppReady"
  [menu]="navigation"
  [pageTitle]="routerUtil.currentModuleName | translate"
  logoUrl="assets/shipm8-logo-reversed.svg"
>
  <router-outlet></router-outlet>
</sh-app-shell>
